// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1r_-0","selects":"Documents_selects__3GaUE"};